import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';

/** `GET /client/:cid/api/key` answers `{id, api: {key}}`; cb answered `{key}`. */
export const getApiKey = async (): Promise<any> => {
  const result = await lpRequest('GET', clientPath('/api/key'));

  return { ...result, key: result.api?.key ?? '' };
};
